<template>
  <div>
    <v-data-table
      style="margin-inline: 10px"
      class="elevation-5"
      :headers="getHeaderTable(headers)"
      :items="filteredRows"
      :items-per-page="15"
      @update:page="page = $event"
      @update:items-per-page="itemsPerPage = $event"
    >
      <template v-slot:top>
        <div
          style="
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            padding-inline: 10px;
          "
        >
          <v-text-field
            v-model="search"
            style="width: 40vh; padding-bottom: 5px"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
          />
          <v-spacer />
          <v-btn
            @click="triggerExcelUpload"
            color="info"
            class="mr-2"
            :loading="isUploading"
            :disabled="isUploading"
          >
            <v-icon left>mdi-file-excel</v-icon>
            Проверить Excel
          </v-btn>
          <input
            type="file"
            ref="excelFileInput"
            accept=".xlsx, .xls"
            style="display: none"
            @change="handleExcelUpload"
          />
          <v-btn
            @click="
              action = 'add';
              selectedPoint = { isActive: true };
              windowsForEditOrAdd = true;
            "
          >
            Добавить
          </v-btn>
        </div>
      </template>
      <template v-slot:item.action="{ isMobile, index }">
        <td v-bind:class="!isMobile ? 'v-data-table__divider' : ''">
          <v-icon
            small
            class="mdi-pencil"
            color="#00AAAA"
            title="Изменение записи"
            @click="
              $router.push({
                path: `/edit-point/${searchRowByIndex(index).ID}`,
              })
            "
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mdi-delete"
            color="#FF0000"
            title="Удаление записи"
            @click="
              windowForDelete = true;
              delayedFunction = function () {
                deletePoint(searchRowByIndex(index).ID);
              };
            "
          >
            mdi-delete
          </v-icon>
          <v-icon
            small
            :class="
              searchRowByIndex(index).isActive ? 'mdi-eye' : 'mdi-eye-off'
            "
            :color="searchRowByIndex(index).isActive ? '#00AA00' : '#AAAAAA'"
            title="Переключить видимость на карте"
            @click="
              toggleActive(
                searchRowByIndex(index).ID,
                searchRowByIndex(index).isActive
              )
            "
          >
            {{ searchRowByIndex(index).isActive ? "mdi-eye" : "mdi-eye-off" }}
          </v-icon>
        </td>
      </template>
      <template
        v-for="header in headers"
        v-slot:[`item.${header.value}`]="{ isMobile, item }"
      >
        <td
          :key="header.value"
          v-if="header.type === 'bool'"
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ item[header.value] ? "Да" : "Нет" }}
        </td>
        <td
          :key="header.value"
          v-else-if="header.type === 'datetime-local'"
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ dateFormatted(item[header.value]) }}
        </td>
        <td
          :key="header.value"
          v-else-if="header.type === 'text-from-dictionary'"
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ formatItemValue(item, header) }}
        </td>
        <td
          :key="header.value"
          v-else
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ item[header.value] }}
        </td>
      </template>
    </v-data-table>
    <!--Форма для редактирования-->
    <v-dialog
      v-if="windowsForEditOrAdd"
      v-model="windowsForEditOrAdd"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{
            action === "update" ? "Редактирование" : "Добавление"
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model="isValid"
            lazy-validation
            style="margin-inline: 1%"
          >
            <table class="table-form">
              <tbody>
                <template v-for="(header, index) in headers">
                  <tr
                    v-if="
                      header.showIf != null
                        ? selectedPoint[header.showIf]
                        : true
                    "
                    :key="index"
                  >
                    <td>
                      <span>{{ header.text }}</span>
                      <v-text-field
                        rows="1"
                        v-if="header.type === 'datetime-local'"
                        outlined
                        :rules="header.rules"
                        type="datetime-local"
                        no-resize
                        v-model.trim="selectedPoint[header.value]"
                      ></v-text-field>
                      <v-text-field
                        rows="1"
                        v-if="header.type === 'number'"
                        outlined
                        :rules="header.rules"
                        type="number"
                        no-resize
                        v-model.number="selectedPoint[header.value]"
                      ></v-text-field>
                      <v-radio-group
                        v-if="header.type === 'bool'"
                        v-model="selectedPoint[header.value]"
                        hide-details
                      >
                        <v-radio :label="`Да`" :value="true"></v-radio>
                        <v-radio :label="`Нет`" :value="false"></v-radio>
                      </v-radio-group>
                      <v-textarea
                        v-if="header.type === 'text'"
                        :rules="header.rules"
                        rows="2"
                        outlined
                        dense
                        v-model.trim="selectedPoint[header.value]"
                      ></v-textarea>
                      <v-autocomplete
                        v-if="header.type === 'text-from-dictionary'"
                        v-model="selectedPoint[header.value]"
                        :items="getDictionary(header.list_name)"
                        :item-text="header.list_text"
                        :item-value="header.list_value"
                        dense
                        outlined
                        :multiple="header.list_multiple"
                      ></v-autocomplete>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="
              windowsForEditOrAdd = false;
              selectedPoint = {};
              $router.push({
                path: '/edit-point',
              });
            "
          >
            Отмена
          </v-btn>
          <v-btn
            :disabled="!isValid"
            color="blue darken-1"
            text
            @click="
              editOrAddRow();
              $router.push({
                path: '/edit-point',
              });
            "
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Оповещение об удалении -->
    <v-dialog
      v-if="windowForDelete"
      v-model="windowForDelete"
      width="400"
      persistent
    >
      <v-card>
        <v-alert type="warning" :value="true"> Внимание</v-alert>
        <v-card-text class="text-md-center">
          Вы действительно хотите удалить данную строку?
        </v-card-text>
        <v-card-actions class="text-lg-right">
          <v-spacer />
          <v-btn
            @click="
              delayedFunction();
              windowForDelete = false;
            "
          >
            Да
          </v-btn>
          <v-btn
            @click="
              windowForDelete = false;
              delayedFunction = function () {};
            "
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="excelDialog" max-width="1300px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Результаты проверки файла</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="excelDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 75vh; overflow-y: auto">
          <v-alert
            :type="excelResults.orgStatus === 'found' ? 'success' : 'error'"
            class="mb-4"
            dense
          >
            <div class="font-weight-bold">
              <template v-if="excelResults.orgStatus === 'found'">
                Организация: {{ excelResults.dbOrganizationName }}
                <div
                  v-if="
                    excelResults.dbOrganizationName !==
                    excelResults.organizationName
                  "
                  class="text-caption font-weight-regular mt-1"
                >
                  <v-icon x-small>mdi-alert-circle-outline</v-icon>
                  В файле указано другое наименование: "{{
                    excelResults.organizationName
                  }}"
                </div>
              </template>
              <template v-else>
                Организация (из файла):
                {{ excelResults.organizationName || "Не указано" }}
              </template>
            </div>

            <div class="mt-1">
              <template v-if="excelResults.orgStatus === 'found'">
                Юр. адрес: {{ excelResults.dbOrganizationAddr || "Не указан" }}
                <div
                  v-if="
                    excelResults.dbOrganizationAddr !==
                    excelResults.organizationAddr
                  "
                  class="text-caption font-weight-regular mt-1"
                >
                  <v-icon x-small>mdi-alert-circle-outline</v-icon>
                  В файле указан другой адрес: "{{
                    excelResults.organizationAddr
                  }}"
                </div>
              </template>
              <template v-else>
                Юр. адрес (из файла):
                {{ excelResults.organizationAddr || "Не указан" }}
              </template>
            </div>

            <div class="mt-2 d-flex align-center flex-wrap" style="gap: 8px">
              <strong>ИНН:</strong>
              <template v-if="excelResults.orgINNMatch">
                <span>{{
                  excelResults.organizationINN ||
                  excelResults.dbOrganizationINN ||
                  "Не указан"
                }}</span>
              </template>
              <template v-else>
                <span class="error--text font-weight-medium"
                  >В файле:
                  {{ excelResults.organizationINN || "Не указан" }}</span
                >
                <span>|</span>
                <span
                  >В базе:
                  {{ excelResults.dbOrganizationINN || "Не указан" }}</span
                >
                <v-icon x-small color="error" title="ИНН не совпадают"
                  >mdi-alert</v-icon
                >
              </template>
            </div>
            <div class="mt-1 text-caption">{{ excelResults.orgMessage }}</div>
          </v-alert>

          <div v-if="excelResults.points && excelResults.points.length > 0">
            <div class="text-subtitle-1 mb-2 font-weight-bold">
              Пункты приёма ({{ excelResults.points.length }} шт.):
            </div>
            <v-data-table
              :headers="excelHeaders"
              :items="excelResults.points"
              :items-per-page="-1"
              hide-default-footer
              class="elevation-1"
              dense
            >
              <template v-slot:item.rawType="{ item }">
                <div class="field-compare">
                  <div :class="getFieldClass(item.rawType)">
                    <v-icon x-small>{{
                      item.rawType.IsMatch ? "mdi-check" : "mdi-alert"
                    }}</v-icon>
                    Файл: {{ item.rawType.excelValue || "—" }}
                  </div>
                  <div
                    class="text-caption mt-1"
                    :class="
                      item.rawType.dbValue === 'Нет в базе'
                        ? 'red--text'
                        : 'grey--text'
                    "
                  >
                    База: {{ item.rawType.dbValue || "Нет в базе" }}
                  </div>
                </div>
              </template>
              <template v-slot:item.address="{ item }">
                <div class="field-compare">
                  <div :class="getFieldClass(item.address)">
                    <v-icon x-small>{{
                      item.address.IsMatch ? "mdi-check" : "mdi-alert"
                    }}</v-icon>
                    Файл: {{ item.address.excelValue || "—" }}
                  </div>
                  <div
                    class="text-caption mt-1"
                    :class="
                      item.address.dbValue === 'Нет в базе'
                        ? 'red--text'
                        : 'grey--text'
                    "
                  >
                    База: {{ item.address.dbValue || "Нет в базе" }}
                  </div>
                </div>
              </template>
              <template v-slot:item.coords="{ item }">
                <div class="field-compare">
                  <div :class="getCoordsClass(item)">
                    <v-icon x-small>{{
                      item.lat.IsMatch && item.lon.IsMatch
                        ? "mdi-check"
                        : "mdi-alert"
                    }}</v-icon>
                    Файл:
                    <template v-if="item.lat.excelValue || item.lon.excelValue">
                      {{ item.lat.excelValue
                      }}<template
                        v-if="item.lat.excelValue && item.lon.excelValue"
                        >, </template
                      >{{ item.lon.excelValue }}
                    </template>
                    <template v-else>—</template>
                  </div>
                  <div
                    class="text-caption mt-1"
                    :class="
                      item.lat.dbValue === 'Нет в базе'
                        ? 'red--text'
                        : 'grey--text'
                    "
                  >
                    База:
                    {{
                      item.lat.dbValue && item.lon.dbValue
                        ? item.lat.dbValue + ", " + item.lon.dbValue
                        : "Нет в базе"
                    }}
                  </div>
                </div>
              </template>
              <template v-slot:item.phone="{ item }">
                <div class="field-compare">
                  <div :class="getFieldClass(item.phone)">
                    <v-icon x-small>{{
                      item.phone.IsMatch ? "mdi-check" : "mdi-alert"
                    }}</v-icon>
                    Файл: {{ item.phone.excelValue || "—" }}
                  </div>
                  <div
                    class="text-caption mt-1"
                    :class="
                      item.phone.dbValue === 'Нет в базе'
                        ? 'red--text'
                        : 'grey--text'
                    "
                  >
                    База: {{ item.phone.dbValue || "Нет в базе" }}
                  </div>
                </div>
              </template>
              <template v-slot:item.status="{ item }">
                <!-- <v-chip :color="getPointStatusColor(item.status)" dark small>
                  <v-icon left x-small>{{
                    getPointStatusIcon(item.status)
                  }}</v-icon>
                  {{ getPointStatusText(item.status) }}
                </v-chip> -->
                <!-- <div class="text-caption grey--text mt-1">
                  {{ item.message }}
                </div> -->
                <div
                  :class="
                    item.status === 'missing_in_file'
                      ? 'error--text font-weight-bold'
                      : 'grey--text'
                  "
                  class="text-caption mt-1"
                >
                  {{ item.message }}
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                  v-if="item.id"
                  small
                  :class="item.isActive ? 'mdi-eye' : 'mdi-eye-off'"
                  :color="item.isActive ? '#00AA00' : '#AAAAAA'"
                  title="Переключить видимость на карте"
                  @click="toggleActive(item.id, item.isActive)"
                >
                  {{ item.isActive ? "mdi-eye" : "mdi-eye-off" }}
                </v-icon>
              </template>
            </v-data-table>
          </div>
          <v-alert v-else type="info" class="mt-4">
            В файле не найдено данных пунктов приёма (начиная с 10 строки).
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="excelDialog = false">
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { bus } from "@/main";

export default {
  name: "edit-point",
  data() {
    return {
      selectedPoint: {},
      isValid: true,
      orgList: [],
      wasteTypes: [],
      action: "",
      delayedFunction: function () {},
      windowsForEditOrAdd: false,
      windowForDelete: false,
      headers: [
        {
          text: "Наименование организации",
          value: "idOrganization",
          divider: true,
          rules: [this.required],
          type: "text-from-dictionary",
          list_name: "organizations",
          list_text: "caption",
          list_value: "ID",
          list_multiple: false,
        },
        {
          text: "Адрес пункта",
          value: "address",
          rules: [this.required],
          divider: true,
          type: "text",
        },
        {
          text: "Телефон",
          value: "phone",
          rules: [(v) => !v || this.rulesPhone(v)],
          divider: true,
          type: "text",
        },
        {
          text: "Типы сырья",
          value: "wasteTypeId",
          divider: true,
          type: "text-from-dictionary",
          list_name: "wasteTypes",
          list_text: "caption",
          list_value: "ID",
          list_multiple: true,
        },
        {
          text: "Широта",
          value: "lat",
          rules: [this.required, this.rulesCoordinates],
          divider: true,
          type: "number",
        },
        {
          text: "Долгота",
          value: "lon",
          divider: true,
          rules: [this.required, this.rulesCoordinates],
          type: "number",
        },
        {
          text: "Активен",
          value: "isActive",
          divider: true,
          type: "bool",
        },
        {
          text: "Примечание пункта",
          value: "description",
          divider: true,
          type: "text",
        },
      ],
      excelHeaders: [
        { text: "Тип сырья", value: "rawType", width: "15%" },
        { text: "Адрес пункта", value: "address", width: "20%" },
        { text: "Координаты", value: "coords", sortable: false, width: "15%" },
        { text: "Телефон", value: "phone", width: "12%" },
        { text: "Статус", value: "status", width: "10%" },
        {
          text: "Действия",
          value: "actions",
          sortable: false,
          width: "10%",
          align: "center",
        },
      ],
      points: [],
      search: "",
      page: 1,
      itemsPerPage: 15,
      excelDialog: false,
      excelResults: [],
      isUploading: false,
    };
  },
  watch: {
    $route(to) {
      if (
        to.params.id !== undefined &&
        to.params.id !== null &&
        to.params.id !== ""
      ) {
        this.getPoint(to.params.id);
        this.action = "update";
        this.windowsForEditOrAdd = true;
      } else {
        this.selectedPoint = {};
        this.windowsForEditOrAdd = false;
        this.action = "";
      }
      this.points.length > 0 ? this.getAllPoints() : null;
    },
  },
  computed: {
    filteredRows() {
      if (this.points != null) {
        let filteredRows = [];
        if (this.search.length < 3 || this.search === "") {
          filteredRows = this.points;
          return filteredRows;
        }
        const searchLower = this.search.toLowerCase();
        this.points.forEach((row) => {
          // Проверяем наименование организации
          const org = this.orgList.find((org) => org.ID === row.idOrganization);
          const orgName = org ? org.caption.toLowerCase() : "";
          // Проверяем типы сырья
          const wasteTypeNames =
            row.wasteTypeId && Array.isArray(row.wasteTypeId)
              ? row.wasteTypeId
                  .map((id) => {
                    const wasteType = this.wasteTypes.find(
                      (type) => type.ID === id
                    );
                    return wasteType ? wasteType.caption.toLowerCase() : "";
                  })
                  .join(" ")
              : "";
          // Проверяем дополнительные поля
          const address = row.address ? row.address.toLowerCase() : "";
          const phone = row.phone ? row.phone.toLowerCase() : "";
          const latitude = row.lat !== undefined ? row.lat.toString() : "";
          const longitude = row.lon !== undefined ? row.lon.toString() : "";
          const notes = row.notes ? row.notes.toLowerCase() : "";
          const description = row.description
            ? row.description.toLowerCase()
            : "";
          // Проверяем, содержится ли искомая строка в наименовании организации, типах сырья или других полях
          if (
            orgName.includes(searchLower) ||
            wasteTypeNames.includes(searchLower) ||
            address.includes(searchLower) ||
            phone.includes(searchLower) ||
            latitude.includes(searchLower) ||
            longitude.includes(searchLower) ||
            notes.includes(searchLower) ||
            description.includes(searchLower)
          ) {
            filteredRows.push(row);
          }
        });
        return filteredRows;
      }
      return [];
    },
  },
  methods: {
    formatItemValue(item, header) {
      if (item[header.value] == null) {
        return null;
      }
      if (Array.isArray(item[header.value])) {
        return this.getDictionary(header.list_name)
          .filter((element) =>
            item[header.value].includes(element[header.list_value])
          )
          .map((element) => element[header.list_text])
          .join(", ");
      } else {
        return this.getDictionary(header.list_name).find((element) => {
          return element[header.list_value] === item[header.value];
        })[header.list_text];
      }
    },
    toggleActive(id, currentStatus) {
      axios
        .post("api/point/toggle-active", {}, { params: { id: id } })
        .then(() => {
          this.getAllPoints();
          if (this.excelResults && this.excelResults.points) {
            const point = this.excelResults.points.find((p) => p.id === id);
            if (point) {
              point.isActive = !currentStatus;
            }
          }
          bus.$emit("message", {
            message: currentStatus
              ? "Пункт скрыт с карты"
              : "Пункт показан на карте",
            color: "green",
          });
        })
        .catch(() => {
          bus.$emit("message", {
            message: "Не удалось изменить статус",
            color: "red",
          });
        });
    },
    dateFormatted(date) {
      if (date == null) {
        return;
      }
      date = date.replace("T", " ");
      date = date.replace("Z", "");
      return date;
    },
    required: (v) => {
      return !!v || "Это обязательное поле";
    },
    rulesCoordinates: (v) => {
      return /^-?\d{1,3}\.\d{1,7}$/.test(v) || "Неверное значение";
    },
    rulesPhone: (v) => {
      return (
        /^((8|\+7)[-]?)?(\(?\d{3}\)?[-]?)?[\d\- ]{7,10}$/.test(v) ||
        "Неверное значение"
      );
    },

    getHeaderTable: function (headers) {
      return [
        {
          text: "Действия",
          value: "action",
          sortable: false,
          divider: true,
        },
        ...headers,
      ];
    },
    editOrAddRow() {
      if (!this.$refs.form.validate()) {
        bus.$emit("message", {
          message: "Информация некорректна",
          color: "red",
        });
        return;
      }
      // eslint-disable-next-line no-unused-vars
      for (const key in this.selectedPoint) {
        if (this.selectedPoint[key].toString().trim() === "") {
          this.selectedPoint[key] = null;
        }
      }
      axios
        .post(`api/point/${this.action}`, this.selectedPoint)
        .then(() => {
          this.$router.push({ path: "/edit-point" });
          this.selectedPoint = {};
          this.windowsForEditOrAdd = false;
          this.action = "";
          this.getAllPoints();
          bus.$emit("message", {
            message: "Сохранено",
            color: "green",
          });
        })
        .catch((e) => {
          if (e.response.status === 401 || e.response.status < 403) {
            bus.$emit("message", {
              message: "Доступ запрещен",
              color: "red",
            });
            return;
          }
          bus.$emit("message", {
            message: "Не удалось внести изменения",
            color: "red",
          });
        });
    },
    getDictionary(key) {
      if (key == null) {
        return [];
      }
      if (key === "organizations") {
        return this.orgList;
      }
      if (key === "wasteTypes") {
        return this.wasteTypes;
      }
      return [];
    },
    // возвращает строчку из уже отфильтрованных строк по индексу в таблице
    searchRowByIndex: function (index) {
      if (this.filteredRows.length === 0) {
        return null;
      }
      return this.filteredRows[(this.page - 1) * this.itemsPerPage + index];
    },
    getAllPoints() {
      axios
        .post("api/point/get/all")
        .then((pointsData) => {
          this.points = pointsData.data;
        })
        .catch((e) => {
          if (e.response.status === 401 || e.response.status < 403) {
            bus.$emit("message", {
              message: "Доступ запрещен",
              color: "red",
            });
            return;
          }
          bus.$emit("message", {
            message: "Не удалось получить точки",
            color: "red",
          });
        });
    },
    deletePoint: function (id) {
      axios
        .post("api/point/delete", {}, { params: { id: id } })
        .then(() => {
          this.getAllPoints();
          bus.$emit("message", {
            message: "Точка удалена",
            color: "green",
          });
        })
        .catch((e) => {
          if (e.response.status === 401 || e.response.status < 403) {
            bus.$emit("message", {
              message: "Доступ запрещен",
              color: "red",
            });
            return;
          }
          bus.$emit("message", {
            message: "Не удалось удалить точку",
            color: "red",
          });
        });
    },
    getPoint: function (id) {
      return new Promise((resolve, reject) => {
        axios
          .post("api/point/get", {}, { params: { id: id } })
          .then((pointData) => {
            this.selectedPoint = pointData.data;
            resolve();
          })
          .catch((e) => {
            if (e.response.status === 401 || e.response.status < 403) {
              bus.$emit("message", {
                message: "Доступ запрещен",
                color: "red",
              });
              reject();
              return;
            }
            bus.$emit("message", {
              message: "Не удалось получить точку",
              color: "red",
            });
            reject();
          });
      });
    },
    getOrgs() {
      return new Promise((resolve, reject) => {
        axios
          .post("api/org/get/all")
          .then((orgsData) => {
            this.orgList = orgsData.data;
            resolve();
          })
          .catch((e) => {
            if (e.response.status === 401 || e.response.status < 403) {
              bus.$emit("message", {
                message: "Доступ запрещен",
                color: "red",
              });
              reject();
              return;
            }
            bus.$emit("message", {
              message: "Не удалось получить список организаций",
              color: "red",
            });
            reject();
          });
      });
    },
    getWasteTypes() {
      return new Promise((resolve, reject) => {
        axios
          .post("api/waste-type/get/all")
          .then((wasteTypesData) => {
            this.wasteTypes = wasteTypesData.data;
            resolve();
          })
          .catch((e) => {
            if (e.response.status === 401 || e.response.status < 403) {
              bus.$emit("message", {
                message: "Доступ запрещен",
                color: "red",
              });
              reject();
              return;
            }
            bus.$emit("message", {
              message: "Не удалось получить список типов отходов" + e,
              color: "red",
            });
            reject();
          });
      });
    },
    triggerExcelUpload() {
      this.$refs.excelFileInput.click();
    },

    async handleExcelUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      event.target.value = "";

      this.isUploading = true;
      this.excelResults = [];

      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await axios.post(
          "/api/point/validate-excel",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.excelResults = response.data || [];
        this.excelDialog = true;

        bus.$emit("message", {
          message: "Проверка файла успешно завершена",
          color: "green",
        });
      } catch (e) {
        console.error(e);
        let errorMsg = "Ошибка при проверке файла";
        if (e.response && e.response.data) {
          errorMsg =
            typeof e.response.data === "string"
              ? e.response.data
              : "Ошибка сервера";
        }
        bus.$emit("message", {
          message: errorMsg,
          color: "red",
        });
      } finally {
        this.isUploading = false;
      }
    },

    getFieldClass(fieldCheck) {
      if (!fieldCheck) return "";
      if (!fieldCheck.dbValue) {
        return "text-success font-weight-medium";
      }
      return fieldCheck.IsMatch
        ? "text-success font-weight-medium"
        : "text-error font-weight-medium";
    },

    getCoordsClass(item) {
      if (!item.lat.dbValue && !item.lon.dbValue) {
        return "text-success font-weight-medium";
      }
      return item.lat.IsMatch && item.lon.IsMatch
        ? "text-success font-weight-medium"
        : "text-error font-weight-medium";
    },

    getPointStatusColor(status) {
      switch (status) {
        case "exists":
          return "blue";
        case "new":
          return "green";
        case "invalid":
          return "orange";
        case "missing_type":
          return "red";
        case "missing_in_file":
          return "purple";
        default:
          return "grey";
      }
    },

    // getPointStatusIcon(status) {
    //   switch (status) {
    //     case "exists":
    //       return "mdi-information";
    //     case "new":
    //       return "mdi-plus-circle";
    //     case "invalid":
    //       return "mdi-alert";
    //     case "missing_type":
    //       return "mdi-alert-circle";
    //     default:
    //       return "mdi-help-circle";
    //   }
    // },

    getPointStatusText(status) {
      switch (status) {
        case "exists":
          return "Существует";
        case "new":
          return "Новый";
        case "invalid":
          return "Ошибка";
        case "missing_type":
          return "Нет типа";
        case "missing_in_file":
          return "Отсутствует в файле";
        default:
          return "Неизвестно";
      }
    },
  },
  async mounted() {
    await this.getOrgs();
    await this.getWasteTypes();
    if (this.$route.params.id !== undefined) {
      await this.getPoint(this.$route.params.id);
      this.action = "update";
      this.windowsForEditOrAdd = true;
    }
    this.getAllPoints();
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
}

.table-form {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  height: auto;
}

.table-form td,
th {
  word-wrap: break-word;
  padding: 5px;
}

v-textarea {
  height: 100%;
}

.status-exists {
  border-left: 4px solid #4caf50;
  background-color: rgba(76, 175, 80, 0.08);
  margin-bottom: 8px;
  border-radius: 4px;
}

.status-missing {
  border-left: 4px solid #f44336;
  background-color: rgba(244, 67, 54, 0.08);
  margin-bottom: 8px;
  border-radius: 4px;
}

.status-invalid {
  border-left: 4px solid #ff9800;
  background-color: rgba(255, 152, 0, 0.08);
  margin-bottom: 8px;
  border-radius: 4px;
}
</style>
